import React, { useState, useEffect } from 'react';
import { 
  Shield, 
  Plus, 
  Search, 
  Filter, 
  Edit3, 
  Trash2, 
  Eye, 
  Save,
  RefreshCw,
  CheckCircle,
  AlertTriangle,
  X,
  Activity,
  Users,
  Calendar,
  FileText,
  Database,
  Server,
  Bell,
  Download,
  Upload,
  MoreHorizontal,
  ChevronDown,
  ChevronRight,
  Copy,
  TestTube,
  BarChart3,
  TrendingUp,
  PieChart,
  Timer,
  Zap,
  AlertCircle,
  CheckSquare,
  Square,
  Star,
  Award,
  TrendingDown,
  Percent,
  DollarSign,
  UserCheck,
  UserX,
  Clock3,
  Clock4,
  Clock5,
  Clock6,
  Clock7,
  Clock8,
  Clock9,
  Clock10,
  Clock11,
  Clock12,
  Send,
  Paperclip,
  Image,
  Link,
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  List,
  Quote,
  Code,
  Palette,
  Type,
  Layout,
  Monitor,
  Smartphone,
  Tablet,
  Key,
  Lock,
  Unlock,
  Globe,
  Wifi,
  HardDrive,
  Cpu,
  Network,
  Mail,
  Phone,
  MapPin,
  Calendar as CalendarIcon,
  Clock,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  CloudSnow,
  Wind,
  Thermometer,
  Droplets,
  Gauge,
  Zap as ZapIcon,
  Battery,
  WifiOff,
  Signal,
  SignalZero,
  SignalLow,
  SignalMedium,
  SignalHigh,
  SignalMax,
  UserPlus,
  UserMinus,
  Settings,
  Home,
  Office,
  Factory,
  Store,
  School,
  Hospital,
  Bank,
  Briefcase,
  GraduationCap,
  Stethoscope,
  CreditCard,
  ShoppingCart,
  BookOpen,
  Heart,
  DollarSign as DollarSignIcon,
  Crown,
  Badge,
  Award as AwardIcon,
  Medal,
  Trophy,
  Certificate,
  Diploma,
  GraduationCap as GraduationCapIcon,
  UserCog,
  UserShield,
  UserCheck as UserCheckIcon,
  UserX as UserXIcon,
  UserPlus as UserPlusIcon,
  UserMinus as UserMinusIcon,
  UserEdit,
  UserSettings,
  UserSearch,
  UserClock,
  UserStar,
  UserHeart,
  UserSmile,
  UserFrown,
  UserMeh,
  UserCheck2,
  UserX2,
  UserPlus2,
  UserMinus2,
  UserEdit2,
  UserSettings2,
  UserSearch2,
  UserClock2,
  UserStar2,
  UserHeart2,
  UserSmile2,
  UserFrown2,
  UserMeh2,
  Archive,
  ArchiveRestore,
  ArchiveX,
  ArchiveCheck,
  ArchivePlus,
  ArchiveMinus,
  ArchiveEdit,
  ArchiveSettings,
  ArchiveSearch,
  ArchiveClock,
  ArchiveStar,
  ArchiveHeart,
  ArchiveSmile,
  ArchiveFrown,
  ArchiveMeh,
  ArchiveCheck2,
  ArchiveX2,
  ArchivePlus2,
  ArchiveMinus2,
  ArchiveEdit2,
  ArchiveSettings2,
  ArchiveSearch2,
  ArchiveClock2,
  ArchiveStar2,
  ArchiveHeart2,
  ArchiveSmile2,
  ArchiveFrown2,
  ArchiveMeh2
} from 'lucide-react';
import MockDataService from '../../services/MockDataService';

const SecurityManagement = () => {
  const [securityData, setSecurityData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('policies');
  const [showPolicyForm, setShowPolicyForm] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCategory, setFilterCategory] = useState('all');
  const [expandedPolicies, setExpandedPolicies] = useState(new Set());
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const fetchSecurityData = async () => {
      try {
        setLoading(true);
        const response = await MockDataService.getSecurityManagement();
        if (response.success) {
          setSecurityData(response.data);
        } else {
          setError('Failed to load security management data');
        }
      } catch (err) {
        setError('Error loading security management data');
        console.error('Security management data error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSecurityData();
  }, []);

  const handleCreatePolicy = () => {
    setSelectedPolicy(null);
    setShowPolicyForm(true);
  };

  const handleEditPolicy = (policy) => {
    setSelectedPolicy(policy);
    setShowPolicyForm(true);
  };

  const handleClosePolicyForm = () => {
    setShowPolicyForm(false);
    setSelectedPolicy(null);
    setHasUnsavedChanges(false);
  };

  const handleSubmitPolicy = (policyData) => {
    //console.log('Submitting policy:', policyData);
    setShowPolicyForm(false);
    setSelectedPolicy(null);
    setHasUnsavedChanges(false);
  };

  const handleDeletePolicy = (policyId) => {
    if (window.confirm('Are you sure you want to delete this security policy?')) {
      //console.log('Deleting policy:', policyId);
    }
  };

  const togglePolicyExpansion = (policyId) => {
    const newExpanded = new Set(expandedPolicies);
    if (newExpanded.has(policyId)) {
      newExpanded.delete(policyId);
    } else {
      newExpanded.add(policyId);
    }
    setExpandedPolicies(newExpanded);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading security management...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <p className="text-red-600 dark:text-red-400">{error}</p>
        </div>
      </div>
    );
  }

  if (!securityData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">No security management data available</p>
        </div>
      </div>
    );
  }

  const { 
    securityManagement, 
    securityStats, 
    recentActivity, 
    securityAnalytics
  } = securityData;

  const { securityPolicies, accessControls, auditLogs, threatDetection } = securityManagement;

  const tabs = [
    { id: 'policies', label: 'Security Policies', icon: Shield },
    { id: 'access', label: 'Access Controls', icon: Lock },
    { id: 'audit', label: 'Audit Logs', icon: FileText },
    { id: 'threats', label: 'Threat Detection', icon: AlertTriangle }
  ];

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'authentication': return Key;
      case 'session': return Clock;
      case 'access': return Lock;
      case 'monitoring': return Eye;
      default: return Shield;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'authentication': return 'blue';
      case 'session': return 'green';
      case 'access': return 'red';
      case 'monitoring': return 'purple';
      default: return 'blue';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-green-600 dark:text-green-400';
      case 'inactive': return 'text-gray-600 dark:text-gray-400';
      case 'detected': return 'text-red-600 dark:text-red-400';
      case 'investigating': return 'text-yellow-600 dark:text-yellow-400';
      default: return 'text-gray-600 dark:text-gray-400';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return CheckCircle;
      case 'inactive': return X;
      case 'detected': return AlertTriangle;
      case 'investigating': return Clock3;
      default: return Clock3;
    }
  };

  const filteredPolicies = securityPolicies.filter(policy => {
    const matchesSearch = policy.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         policy.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = filterStatus === 'all' || policy.status === filterStatus;
    const matchesCategory = filterCategory === 'all' || policy.category === filterCategory;
    return matchesSearch && matchesStatus && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <Shield className="h-8 w-8 text-blue-600 dark:text-blue-400" />
              <div>
                <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                  Security Management
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Manage security policies and access controls
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              {hasUnsavedChanges && (
                <div className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-orange-600 dark:text-orange-400 bg-orange-100 dark:bg-orange-900 rounded-md">
                  <AlertTriangle className="h-4 w-4" />
                  <span>Unsaved Changes</span>
                </div>
              )}
              <button className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                <Download className="h-4 w-4" />
                <span>Export</span>
              </button>
              <button
                onClick={handleCreatePolicy}
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                <Plus className="h-4 w-4" />
                <span>Create Policy</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Security Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                <Shield className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Security Policies</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{securityStats.totalPolicies}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-green-100 dark:bg-green-900 rounded-lg">
                <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Active Policies</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{securityStats.activePolicies}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-orange-100 dark:bg-orange-900 rounded-lg">
                <AlertTriangle className="h-6 w-6 text-orange-600 dark:text-orange-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Threats Detected</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{securityStats.threatsDetected}</p>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <div className="p-2 bg-purple-100 dark:bg-purple-900 rounded-lg">
                <TrendingUp className="h-6 w-6 text-purple-600 dark:text-purple-400" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Security Score</p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{securityStats.securityScore}%</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Security Management</h3>
                <nav className="space-y-2">
                  {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`w-full flex items-center space-x-3 px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                          activeTab === tab.id
                            ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300'
                            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                        }`}
                      >
                        <Icon className="h-4 w-4" />
                        <span>{tab.label}</span>
                      </button>
                    );
                  })}
                </nav>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              {/* Policies Tab */}
              {activeTab === 'policies' && (
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Security Policies</h2>
                    <div className="flex items-center space-x-2">
                      <button className="flex items-center space-x-1 px-3 py-1 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
                        <RefreshCw className="h-4 w-4" />
                        <span>Refresh</span>
                      </button>
                    </div>
                  </div>

                  {/* Search and Filters */}
                  <div className="flex flex-col sm:flex-row gap-4 mb-6">
                    <div className="flex-1">
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Search policies..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <select
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      >
                        <option value="all">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                      <select
                        value={filterCategory}
                        onChange={(e) => setFilterCategory(e.target.value)}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                      >
                        <option value="all">All Categories</option>
                        <option value="authentication">Authentication</option>
                        <option value="session">Session</option>
                        <option value="access">Access</option>
                        <option value="monitoring">Monitoring</option>
                      </select>
                    </div>
                  </div>

                  {/* Policies List */}
                  <div className="space-y-3">
                    {filteredPolicies.map((policy) => {
                      const CategoryIcon = getCategoryIcon(policy.category);
                      const StatusIcon = getStatusIcon(policy.status);
                      const isExpanded = expandedPolicies.has(policy.id);
                      
                      return (
                        <div key={policy.id} className="border border-gray-200 dark:border-gray-700 rounded-lg">
                          <div className="flex items-center justify-between p-4">
                            <div className="flex items-center space-x-4">
                              <button
                                onClick={() => togglePolicyExpansion(policy.id)}
                                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                              >
                                {isExpanded ? (
                                  <ChevronDown className="h-4 w-4 text-gray-400" />
                                ) : (
                                  <ChevronRight className="h-4 w-4 text-gray-400" />
                                )}
                              </button>
                              <div className={`p-2 bg-${getCategoryColor(policy.category)}-100 dark:bg-${getCategoryColor(policy.category)}-900 rounded-lg`}>
                                <CategoryIcon className={`h-4 w-4 text-${getCategoryColor(policy.category)}-600 dark:text-${getCategoryColor(policy.category)}-400`} />
                              </div>
                              <div className="flex-1">
                                <div className="flex items-center space-x-2 mb-1">
                                  <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">{policy.name}</h3>
                                  <span className="text-xs text-gray-500 dark:text-gray-400">{policy.category}</span>
                                </div>
                                <p className="text-sm text-gray-600 dark:text-gray-400">{policy.description}</p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <StatusIcon className={`h-4 w-4 ${getStatusColor(policy.status)}`} />
                              <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                                policy.status === 'active' ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' :
                                'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                              }`}>
                                {policy.status}
                              </span>
                              <div className="flex items-center space-x-1">
                                <button
                                  onClick={() => handleEditPolicy(policy)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                >
                                  <Edit3 className="h-4 w-4 text-gray-400" />
                                </button>
                                <button
                                  onClick={() => handleDeletePolicy(policy.id)}
                                  className="p-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded"
                                >
                                  <Trash2 className="h-4 w-4 text-gray-400" />
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Expanded Policy Details */}
                          {isExpanded && (
                            <div className="border-t border-gray-200 dark:border-gray-700 p-4 bg-gray-50 dark:bg-gray-700">
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                  <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Policy Details</h4>
                                  <div className="space-y-2">
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Priority:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{policy.priority}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Created:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{new Date(policy.createdDate).toLocaleDateString()}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-600 dark:text-gray-400">Last Modified:</span>
                                      <span className="text-gray-900 dark:text-gray-100">{new Date(policy.lastModified).toLocaleDateString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Policy Rules</h4>
                                  <div className="space-y-1">
                                    {policy.rules.map((rule, index) => (
                                      <div key={index} className="text-sm text-gray-700 dark:text-gray-300">
                                        • {rule}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Other tabs would be implemented similarly */}
              {activeTab === 'access' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Access Controls</h2>
                  <p className="text-gray-600 dark:text-gray-400">Access control management coming soon...</p>
                </div>
              )}

              {activeTab === 'audit' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Audit Logs</h2>
                  <p className="text-gray-600 dark:text-gray-400">Audit log management coming soon...</p>
                </div>
              )}

              {activeTab === 'threats' && (
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Threat Detection</h2>
                  <p className="text-gray-600 dark:text-gray-400">Threat detection coming soon...</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Policy Form Modal */}
      {showPolicyForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-2xl mx-4">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {selectedPolicy ? 'Edit Security Policy' : 'Create New Security Policy'}
              </h3>
              <button
                onClick={handleClosePolicyForm}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Policy Name
                  </label>
                  <input
                    type="text"
                    defaultValue={selectedPolicy?.name || ''}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Enter policy name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Category
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
                    <option value="authentication">Authentication</option>
                    <option value="session">Session</option>
                    <option value="access">Access</option>
                    <option value="monitoring">Monitoring</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Description
                </label>
                <textarea
                  rows={3}
                  defaultValue={selectedPolicy?.description || ''}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                  placeholder="Enter policy description"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Priority
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
                    <option value="high">High</option>
                    <option value="medium">Medium</option>
                    <option value="low">Low</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Status
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end space-x-3 mt-6">
              <button
                onClick={handleClosePolicyForm}
                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => handleSubmitPolicy({})}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                {selectedPolicy ? 'Update Policy' : 'Create Policy'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecurityManagement;
